export function VerticalDivider() {
    return (
        <div
            className="slds-var-m-horizontal_large"
            style={{
                width: "2px",
                height: "100%",
                border: "2px",
                background: "#E3E8E9",
            }}
        ></div>
    );
}
